import { DateTime } from "@/util";

export function getExpirationDate(date: string | Date | undefined) {
  if (date) {
    const localDate = DateTime.getLocalDate(date);
    return <span style={new Date(date) < new Date() ? { color: "red" } : {}}>{localDate}</span>;
  }
}
